import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  logo: {
    width: '100%',
    marginBottom: '30px',
    '@media(max-width: 1300px)': {
      maxWidth: '325px',
    },
  },
  cardLogin: {
    width: '20vw',
    display: 'flex',
    alignItems: 'center',
    padding: '32px 48px',
    flexDirection: 'column',
    '@media(max-width: 1300px)': {
      width: '70vw',
      padding: '20px 30px',
      maxWidth: '600px',
    },
  },
  input: {
    marginBottom: '10px',
  },
  submitButton: {
    marginLeft: 'auto',
    width: 'fit-content',
    fontWeight: 'bold',
  },
  errorText: {
    color: 'red',
    marginTop: '10px',
  },
});
